








import { Component, Prop, Vue } from 'vue-property-decorator'
import { MessageModel } from '../models'

@Component
export default class Ticker extends Vue {
  @Prop() messages: MessageModel[]
  @Prop() emergency: boolean

  get messagesLength() {
    return this.messages.join(' ').length + this.messages.length * 20
  }
}
